var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#425893"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.584 26.3601L30.2642 22.0385H26.0744V19.2296C26.0744 18.0479 26.6593 16.8932 28.5297 16.8932H30.4614V13.2132C29.3365 13.0338 28.1998 12.9368 27.0606 12.9229C23.6122 12.9229 21.3608 14.9958 21.3608 18.7434V22.0385H17.5383V26.3601H21.3608V36.8127H26.0744V26.3601H29.584Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.1295fff0105134af6489177c21794395.svg";
export { ForwardRef as ReactComponent };